export default $axios => ({
  resource: 'measurement',
  /**
   * Delete multiple ids
   */
  deleteMulti(data, config) {
    return $axios.post('delete-measurements', data, config)
  }
})
